export default theme => ({
  paginatedtable: {
    overflow: "auto",
    minHeight: 300,
  },
});
